/**
 * CNPJ validation utilities
 */

/**
 * Remove all non-digit characters from a string
 */
export const getOnlyDigits = (value?: string | any): string => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.replace(/\D/g, '');
};

/**
 * Check if CNPJ has valid format and checksum
 */
export const isValidCnpj = (cnpj?: string): boolean => {
  if (!cnpj) return false;

  const digits = getOnlyDigits(cnpj);

  // Must have exactly 14 digits
  if (digits.length !== 14) return false;

  // Cannot be all same digits
  if (digits.split('').every((digit) => digit === digits[0])) return false;

  // Validate first check digit
  let sum = 0;
  let weight = 5;

  for (let i = 0; i < 12; i += 1) {
    sum += parseInt(digits[i], 10) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }

  const firstCheckDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(digits[12], 10) !== firstCheckDigit) return false;

  // Validate second check digit
  sum = 0;
  weight = 6;

  for (let i = 0; i < 13; i += 1) {
    sum += parseInt(digits[i], 10) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }

  const secondCheckDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (parseInt(digits[13], 10) !== secondCheckDigit) return false;

  return true;
};

/**
 * Format CNPJ with mask
 */
export const formatCnpj = (cnpj?: string): string => {
  const digits = getOnlyDigits(cnpj);
  return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
};
